"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getProfileData = exports.getResourceData = exports.getRoomingListData = exports.getRequirementData = exports.getCheckinData = exports.getTransportData = exports.getTransferServiceData = exports.getServicesData = exports.getLinkedBookingCustomersData = exports.getPrimaryCustomerData = exports.getBookingMetaData = exports.getBookingData = exports.POST_FLIGHT_SEGMENT_URL = undefined;

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

exports.deleteResource = deleteResource;
exports.patchResource = patchResource;
exports.postResource = postResource;
exports.getAuthToken = getAuthToken;
exports.postMessage = postMessage;
exports.loadOptions = loadOptions;

var _isomorphicFetch = require("isomorphic-fetch");

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _ravenJs = require("raven-js");

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _REQUIREMENT_SET_CODES = require("metadata/REQUIREMENT_SET_CODES");

var _REQUIREMENT_SET_CODES2 = _interopRequireDefault(_REQUIREMENT_SET_CODES);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// __DEVELOPMENT__, publicAppKey, gapiBaseURL are globals (defined with webpack's definePlugin)
var POST_FLIGHT_SEGMENT_URL = exports.POST_FLIGHT_SEGMENT_URL = gapiBaseURL + "/flight_segments/";

function generateAPIHeaders(_ref) {
    var _ref$locale = _ref.locale,
        locale = _ref$locale === undefined ? "en" : _ref$locale,
        authToken = _ref.authToken,
        bypassCache = _ref.bypassCache;

    var headers = {
        Accept: "application/json",
        "Accept-Language": locale,
        "Content-Type": "application/json"
    };
    if (authToken) {
        headers["X-Application-Key"] = authToken;
    }
    if (bypassCache) {
        headers["X-Fastly-Bypass"] = "pass";
    }
    return headers;
}

// We don't want to map any errors for the following statuses
var FAIL_STATUSES = [401];
var TIMEOUT_STATUSES = [503, 504];

function parseResponse(response) {
    var isTimeout = TIMEOUT_STATUSES.includes(response.status);
    // Parse response and check for errors
    return response.text().then(function (text) {
        // response.json() fails for 204 responses
        var data = text && !isTimeout ? JSON.parse(text) : {};
        if (!response.ok) {
            if (!FAIL_STATUSES.includes(response.status) && data.errors && data.errors.length > 0) {
                // (network will sometimes pass helpful errors for us to extract/map in sagas)
                return _promise2.default.reject({
                    errors: data.errors,
                    responseLog: response
                });
            } else {
                // no errors array from network, just reject with string of status, url & statusText
                return _promise2.default.reject({
                    _error: isTimeout ? "Failed to load vital resource, please refresh the page and try again." : response.status + " " + response.url + " - " + response.statusText,
                    responseLog: response
                });
            }
        }
        return data;
    });
}

// TODO: Paging?
// Used to extract results from API requests which return their results as an
// object with keys: 'count', 'current_page', 'links', 'max_per_page', 'results'
function extractResults(_ref2) {
    var parsedResponse = _ref2.parsedResponse,
        _ref2$dontThrow = _ref2.dontThrow,
        dontThrow = _ref2$dontThrow === undefined ? false : _ref2$dontThrow;

    if (parsedResponse.results) {
        if (parsedResponse.results.length === 0 && !dontThrow) {
            return _promise2.default.reject({
                _error: "No results returned for required resource."
            });
        } else {
            return parsedResponse.results;
        }
    } else {
        return parsedResponse;
    }
}

function extractRequirementByCode(_ref3) {
    var parsedResponse = _ref3.parsedResponse,
        _ref3$dontThrow = _ref3.dontThrow,
        dontThrow = _ref3$dontThrow === undefined ? false : _ref3$dontThrow;

    if (parsedResponse.count === 0) {
        if (parsedResponse.error && !dontThrow) {
            _promise2.default.reject({ _error: "Error at get." });
        } else {
            return _promise2.default.reject({
                _error: "No results returned for required resource."
            });
        }
    }
    return parsedResponse.results[0];
}

function extractResourceName(url) {
    var resourceName = "";
    var baseUrl = gapiBaseURL + "/";
    if (url.indexOf(baseUrl) !== -1) {
        var resourcePart = url.slice(baseUrl.length);
        if (resourcePart.length > 0) {
            var slashIndex = resourcePart.indexOf("/");
            resourceName = slashIndex !== -1 ? resourcePart.slice(0, slashIndex) : resourcePart;
        }
    }
    return resourceName || "could not extract";
}

function sendError(error, requestInfo) {
    var method = requestInfo.method,
        resourceType = requestInfo.resourceType;


    if (!error.errors) {
        // Ensure if not a validation error that user gets presented with some error
        // (and not an infinite loading screen)
        error._error = error._error || error.message || "An error has occured."; // latter should never be shown!
    }

    // Log API call error to Sentry
    if (!__DEVELOPMENT__) {
        var responseStatus = error.responseLog && error.responseLog.status || "?";
        if (error.errors) {
            error.errors.forEach(function (errorObj) {
                var errorCode = errorObj.code;
                _ravenJs2.default.captureException("(API) " + errorCode + " | " + responseStatus + " - " + method + " " + resourceType, {
                    fingerprint: ["API", errorCode, responseStatus, method, resourceType],
                    level: "info", // we just want to know what errors users make
                    extra: {
                        error: errorObj,
                        request: requestInfo,
                        response: error.responseLog
                    }
                });
            });
        } else {
            var msgText = error.responseLog && error.responseLog.statusText || error._error;
            _ravenJs2.default.captureException("(API) " + msgText + " | " + responseStatus + " - " + method + " " + resourceType, {
                fingerprint: ["API", msgText, responseStatus, method, resourceType],
                level: responseStatus == 401 ? "info" : "error", // auth errors should be 'info'
                extra: {
                    errorMsg: msgText,
                    request: requestInfo,
                    response: error.responseLog
                }
            });
        }
    }
    return { error: error };
}

function fetchRequirement(props) {
    // position and cache will be undefined for first item of the array
    var position = props.position,
        url = props.url,
        headers = props.headers,
        method = props.method;
    var cache = props.cache;

    var code = _REQUIREMENT_SET_CODES2.default[position ? position : 0];
    var next = position ? position + 1 : 1;

    return (0, _isomorphicFetch2.default)(url + "?code=" + code, { headers: headers, method: method }).then(parseResponse).then(function (parsedResponse) {
        var reqSet = extractRequirementByCode({ parsedResponse: parsedResponse });
        if (!cache) {
            cache = [];
        }
        return {
            data: reqSet,
            next: next,
            combined: [].concat((0, _toConsumableArray3.default)(cache), [reqSet])
        };
    }).catch(function (error) {
        return sendError(error, {
            url: url,
            headers: headers,
            method: method,
            resourceType: "requirements"
        });
    });
}

function fetchNextPromiseCreator(nextPos, cache, url, headers, method) {
    return fetchRequirement({
        position: nextPos,
        cache: cache,
        url: url,
        headers: headers,
        method: method
    }).then(function (_ref4) {
        var next = _ref4.next,
            combined = _ref4.combined;

        return {
            combined: combined,
            newNextPos: next
        };
    }).catch(function (err) {

    }).then(function (_ref5) {
        var combined = _ref5.combined,
            newNextPos = _ref5.newNextPos;

        if (newNextPos <= _REQUIREMENT_SET_CODES2.default.length - 1) {
            return fetchNextPromiseCreator(newNextPos, combined, url, headers, method);
        } else {
            return combined;
        }
    });
}

var fetchRequirements = function fetchRequirements(_ref6) {
    var headers = _ref6.headers,
        method = _ref6.method,
        url = _ref6.url,
        returnProp = _ref6.returnProp;

    return fetchRequirement({ url: url, headers: headers, method: method }).then(function (_ref7) {
        var data = _ref7.data,
            next = _ref7.next;

        if (next <= _REQUIREMENT_SET_CODES2.default.length - 1) {
            return fetchNextPromiseCreator(next, [data], url, headers, method);
        }
    }).then(function (combined) {
        return (0, _defineProperty3.default)({}, returnProp, combined.filter(function (set) {
            return set.id;
        }));
    });
};

function getRequirementDataRaw(_ref9) {
    var authToken = _ref9.authToken,
        locale = _ref9.locale,
        url = _ref9.url,
        returnProp = _ref9.returnProp,
        resourceType = _ref9.resourceType,
        _ref9$extract = _ref9.extract,
        extract = _ref9$extract === undefined ? true : _ref9$extract;

    var headers = generateAPIHeaders({ authToken: authToken, locale: locale });
    var method = "GET";
    return fetchRequirements({
        headers: headers,
        method: method,
        url: url,
        returnProp: returnProp,
        resourceType: resourceType,
        extract: extract
    });
}

function getData(_ref10) {
    var authToken = _ref10.authToken,
        locale = _ref10.locale,
        url = _ref10.url,
        returnProp = _ref10.returnProp,
        resourceType = _ref10.resourceType,
        _ref10$extract = _ref10.extract,
        extract = _ref10$extract === undefined ? true : _ref10$extract;

    var headers = generateAPIHeaders({ authToken: authToken, locale: locale });
    var method = "GET";

    return (0, _isomorphicFetch2.default)(url, { headers: headers, method: method }).then(parseResponse).then(function (parsedResponse) {
        if (extract) {
            return extractResults({ parsedResponse: parsedResponse });
        } else {
            return parsedResponse;
        }
    }).then(function (resultData) {
        return (0, _defineProperty3.default)({}, returnProp, resultData);
    }).catch(function (error) {
        return sendError(error, { url: url, headers: headers, method: method, resourceType: resourceType });
    });
}
var getBookingData = exports.getBookingData = function getBookingData(bookingId, authToken, locale) {
    return getData({
        authToken: authToken,
        locale: locale,
        url: gapiBaseURL + "/bookings/" + bookingId,
        returnProp: "bookingData",
        resourceType: "bookings"
    });
};
var getBookingMetaData = exports.getBookingMetaData = function getBookingMetaData(bookingId, authToken, locale) {
    return getData({
        authToken: authToken,
        locale: locale,
        url: gapiBaseURL + "/bookings_meta/" + bookingId,
        returnProp: "bookingMetaData",
        resourceType: "bookings_meta"
    });
};

var getPrimaryCustomerData = exports.getPrimaryCustomerData = function getPrimaryCustomerData(customerId, authToken, locale) {
    return getData({
        authToken: authToken,
        locale: locale,
        url: gapiBaseURL + "/customers/" + customerId,
        returnProp: "primaryCustomerData",
        resourceType: "customers"
    });
};

var getLinkedBookingCustomersData = exports.getLinkedBookingCustomersData = function getLinkedBookingCustomersData(bookingId, authToken, locale) {
    return getData({
        authToken: authToken,
        locale: locale,
        url: gapiBaseURL + "/bookings/" + bookingId + "/customers",
        returnProp: "bookingCustomersData",
        resourceType: "customers"
    });
};

var getServicesData = exports.getServicesData = function getServicesData(bookingId, authToken, locale) {
    return getData({
        authToken: authToken,
        locale: locale,
        url: gapiBaseURL + "/bookings/" + bookingId + "/services",
        returnProp: "servicesData",
        resourceType: "services"
    });
};

var getTransferServiceData = exports.getTransferServiceData = function getTransferServiceData(transferServiceId, authToken, locale) {
    return getData({
        authToken: authToken,
        locale: locale,
        url: gapiBaseURL + "/transport_services/" + transferServiceId,
        returnProp: "transferServiceData",
        resourceType: "transport_services"
    });
};

var getTransportData = exports.getTransportData = function getTransportData(transportId, authToken, locale) {
    return getData({
        authToken: authToken,
        locale: locale,
        url: gapiBaseURL + "/transports/" + transportId,
        returnProp: "transportData",
        resourceType: "transports"
    });
};

var getCheckinData = exports.getCheckinData = function getCheckinData(bookingId, authToken, locale) {
    return getData({
        authToken: authToken,
        locale: locale,
        url: gapiBaseURL + "/bookings/" + bookingId + "/checkins",
        returnProp: "checkinData",
        resourceType: "checkins"
    });
};

var getRequirementData = exports.getRequirementData = function getRequirementData(bookingId, servicesCount, authToken, locale) {
    if (servicesCount > 30) {
        return getRequirementDataRaw({
            bookingId: bookingId,
            authToken: authToken,
            locale: locale,
            url: gapiBaseURL + "/bookings/" + bookingId + "/requirements",
            returnProp: "requirementData",
            resourceType: "requirements"
        });
    } else {
        return getData({
            authToken: authToken,
            locale: locale,
            url: gapiBaseURL + "/bookings/" + bookingId + "/requirements",
            returnProp: "requirementData",
            resourceType: "requirements"
        });
    }
};

var getRoomingListData = exports.getRoomingListData = function getRoomingListData(productId, authToken, locale) {
    return getData({
        authToken: authToken,
        locale: locale,
        url: gapiBaseURL + "/rooming_lists/" + productId,
        returnProp: "roomingListData",
        resourceType: "rooming_lists"
    });
};

var getResourceData = exports.getResourceData = function getResourceData(resourceId, resourceType, authToken, locale) {
    return getData({
        authToken: authToken,
        locale: locale,
        url: gapiBaseURL + "/" + resourceType + "/" + resourceId,
        returnProp: "resourceData",
        resourceType: resourceType,
        extract: false
    });
};
var getProfileData = exports.getProfileData = function getProfileData(customerId, authToken, locale) {
    return getData({
        authToken: authToken,
        locale: locale,
        url: gapiBaseURL + "/profiles?customer_id=" + customerId,
        returnProp: "profileData",
        resourceType: "profiles"
    });
};

function deleteResource(resourceHref, authToken) {
    var url = resourceHref;
    var headers = generateAPIHeaders({ authToken: authToken });
    var method = "DELETE";

    return (0, _isomorphicFetch2.default)(url, { headers: headers, method: method }).then(parseResponse).then(function (deleteSucceededResource) {
        return { deleteSucceededResource: deleteSucceededResource };
    }).catch(function (error) {
        return sendError(error, {
            url: url,
            headers: headers,
            method: method,
            resourceType: extractResourceName(url)
        });
    });
}

function patchResource(resourceHref, resource, authToken) {
    var url = resourceHref;
    var headers = generateAPIHeaders({ authToken: authToken });
    var method = "PATCH";
    var body = (0, _stringify2.default)(resource);

    return (0, _isomorphicFetch2.default)(url, { headers: headers, method: method, body: body }).then(parseResponse).then(function (patchSucceededResource) {
        return { patchSucceededResource: patchSucceededResource };
    }).catch(function (error) {
        return sendError(error, {
            url: url,
            headers: headers,
            method: method,
            body: body,
            resourceType: extractResourceName(url)
        });
    });
}

function postResource(resourceHref, resource, authToken) {
    var url = resourceHref;
    var headers = generateAPIHeaders({ authToken: authToken });
    var method = "POST";
    var body = (0, _stringify2.default)(resource);

    return (0, _isomorphicFetch2.default)(url, { headers: headers, method: method, body: body }).then(parseResponse).then(function (postSucceededResource) {
        return { postSucceededResource: postSucceededResource };
    }).catch(function (error) {
        return sendError(error, {
            url: url,
            headers: headers,
            method: method,
            body: body,
            resourceType: extractResourceName(url)
        });
    });
}

function getAuthToken(authParams) {
    var url = gapiBaseURL + "/oauth/token/";
    var headers = generateAPIHeaders({ authToken: authParams.apiClientKey ? authParams.apiClientKey : publicAppKey });
    var method = "POST";
    var body = (0, _stringify2.default)({
        grant_type: "password",
        scope: "read_write_obfuscated",
        credentials: {
            booking_id: authParams.bookingId,
            customer_id: authParams.customerId,
            nationality: authParams.nationality,
            date_of_birth: authParams.date_of_birth
        }
    });

    return (0, _isomorphicFetch2.default)(url, { headers: headers, method: method, body: body }).then(parseResponse).then(function (authTokenData) {
        return { authTokenData: authTokenData };
    }).catch(function (error) {
        return sendError(error, {
            url: url,
            headers: headers,
            method: method,
            body: body,
            resourceType: "oauth/token"
        });
    });
}

function postMessage(message, authToken) {
    var url = gapiBaseURL + "/messages";
    var headers = generateAPIHeaders({ authToken: authToken });
    var method = "POST";
    var body = (0, _stringify2.default)(message);

    return (0, _isomorphicFetch2.default)(url, { headers: headers, method: method, body: body }).then(parseResponse).then(function (postSucceededMessage) {
        return { postSucceededMessage: postSucceededMessage };
    }).catch(function (error) {
        return sendError(error, {
            url: url,
            headers: headers,
            method: method,
            body: body,
            resourceType: "messages"
        });
    });
}

function loadOptions(_ref12) {
    var input = _ref12.input,
        queryParam = _ref12.queryParam,
        resource = _ref12.resource,
        _ref12$fuzzy = _ref12.fuzzy,
        fuzzy = _ref12$fuzzy === undefined ? false : _ref12$fuzzy,
        fuzzyParam = _ref12.fuzzyParam,
        locale = _ref12.locale,
        _ref12$searchParams = _ref12.searchParams,
        searchParams = _ref12$searchParams === undefined ? false : _ref12$searchParams;

    var searchStr = searchParams ? searchParams.reduce(function (a, v) {
        return a + "&" + v.name + "=" + v.value;
    }, "") : "";

    var query = fuzzy ? "?" + (fuzzyParam || "query") + "__like=" + input + "*" + searchStr : queryParam ? "?" + queryParam + "=" + input : "" + input;
    var url = gapiBaseURL + "/" + resource + "/" + query;
    var headers = generateAPIHeaders({ authToken: publicAppKey, locale: locale });
    var method = "GET";

    return (0, _isomorphicFetch2.default)(url, { headers: headers, method: method }).then(parseResponse).then(function (parsedResponse) {
        return extractResults({ parsedResponse: parsedResponse, dontThrow: true });
    }).then(function (results) {
        return { results: results };
    }).catch(function (error) {
        return sendError(error, { url: url, headers: headers, method: method, resourceType: resource });
    });
}


//////////////////
// WEBPACK FOOTER
// ./app/api/api-helper.js
// module id = 39
// module chunks = 0